<script>
  import date from '../functions-common/date';

  export let project;
  export let editMode = false;

  const formatDate = dateStr => dateStr ? date.formatDate(date.dateFromString(dateStr)) : '-';

  $: startDate = formatDate(project.start);
  $: endDate = formatDate(project.end);
  $: maxAttemptTime = project.max_time_for_attempt ? date.formatDuration(project.max_time_for_attempt, 'long') : '-';
</script>

{#if project}
  <dl>
    <div class="row">
      <div>
        <dt>Start</dt>
        <dd>
          {#if !editMode}
            {startDate}
          {:else}
            <input type="datetime-local" class="nes-input" bind:value={project.startEdit}/>
          {/if}
        </dd>
      </div>

      <div>
        <dt>End</dt>
        <dd>
          {#if !editMode}
            {endDate}
          {:else}
            <input type="datetime-local" class="nes-input" bind:value={project.endEdit}/>
          {/if}
        </dd>
      </div>
    </div>

    <div class="row">
      <div>
        <dt>Max attempts per map</dt>
        <dd>
          {#if !editMode}
            {project.max_attempts}
          {:else}
            <input type="number" class="nes-input" bind:value={project.max_attempts} min="1"/>
          {/if}
        </dd>
      </div>

      <div>
        <dt>Max attempt time{editMode ? ' (secs)' : ''}</dt>
        <dd>
          {#if !editMode}
            {maxAttemptTime}
          {:else}
            <input type="number" class="nes-input" bind:value={project.max_time_for_attempt} min="1"/>
          {/if}
        </dd>
      </div>
    </div>

    {#if editMode}
      <div class="row">
        <div>
          <dt>Token validity (secs)</dt>
          <dd>
            <input type="number" class="nes-input" bind:value={project.token_validity} min="1"/>
          </dd>
        </div>

        <div>
          <label>
            <input type="checkbox" class="nes-checkbox is-dark" bind:checked={project.main}>
            <span>Set as main</span>
          </label>
        </div>
      </div>
    {/if}
  </dl>
{/if}

<style>
    .row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .row > * {
        width: 50%;
    }

    .row > *:last-child {
        margin-left: 1rem;
    }

    dt {
        color: #888;
        margin-bottom: .25rem;
    }

    dd {
        margin-bottom: 1rem;
    }

    input {
        margin-left: -4px;
    }

    label {
        margin-top: 1rem;
        margin-bottom: 0;
        margin-left: 1rem;
    }

    label > span {
        padding-top: .25rem;
        padding-left: .25rem;
    }

    @media screen and (max-width: 767px) {
        .row {
            display: block;
        }

        .row > * {
            width: 100%;
            text-align: center;
        }

        .row > *:last-child {
            margin-left: 0;
        }
    }
</style>